import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { View, Platform, StyleSheet } from 'react-native';

import Theme from '../theme';
import { BaseModal } from '../ui';
import { UserDataConsumer } from '../utils';
import { PrivacyHeader, PrivacySettings } from './components';
import AllowedPartners from './AllowedPartners';
import WorkoutPartnersTabNavigation from './WorkoutPartnersTabNavigation';
import { Button } from '../components';
import { togglePrivacySettingsModal } from '../ui/redux/uiActions';

class WorkoutPartnersScreen extends Component {
    constructor(props) {
        super(props);

        const {
            user: {
                userProfile: {
                    privateProfile = false,
                },
            }
        } = this.props;

        this.state = {
            privateProfile,
            isLoading: false,
        };
    }

    toggleSettingsModal = () => {
        const { isModalVisible } = this.props;
        this.props.togglePrivacySettingsModal(!isModalVisible);
    }

    closeSettings = () => {
        this.props.togglePrivacySettingsModal(false);
    }

    setProfileToPrivate = async () => {
        await this.setState({ privateProfile: true });
    }
    
    setProfileToPublic = async () => {
        await this.setState({ privateProfile: false });
    }

    updateProfilePrivacy = async () => {
        const { user: { userProfileService } } = this.props;
        const { privateProfile } = this.state;
        try {
            this.setState({ isLoading: true });
            await userProfileService.setUserProfilePrivacySetting(privateProfile);
            this.closeSettings();
        } catch (error) {

        } finally {
            this.setState({ isLoading: false });
        }
    }

    render() {
        const {
            isLoading,
            privateProfile: statePrivateProfile,
        } = this.state;
        const { t } = this.props; 
        const {
            isModalVisible,
            user: {
                userProfile: {
                    privateProfile = false,
                },
            },
        } = this.props;

        return (
            <View style={styles.container}>
                <PrivacyHeader
                    t={t}
                    isPrivate={privateProfile}
                    toggleSettingsModal={this.toggleSettingsModal}
                />
                {privateProfile
                    ?
                        <AllowedPartners />
                    :
                        <WorkoutPartnersTabNavigation />
                }
                <BaseModal
                    closeModal={this.closeSettings}
                    title={t('privacyModalSettings')}
                    isModalVisible={isModalVisible}>
                    <View style={styles.modalContainer}>
                        <PrivacySettings
                            privateProfile={statePrivateProfile}
                            setProfileToPrivate={this.setProfileToPrivate}
                            setProfileToPublic={this.setProfileToPublic}
                        />
                        <View style={styles.footer}>
                            <Button
                                fontColor={Theme.WHITE}
                                isLoading={isLoading}
                                title="Save Settings"
                                onPress={this.updateProfilePrivacy}
                            />
                        </View>
                    </View>
                </BaseModal>
            </View>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: Platform.OS === 'web' ? Theme.CHARCOAL : Theme.WHITE,
    },
    modalContainer: {
        flex: 1,
        paddingHorizontal: 15,
    },
    footer: {
        flex: 1,
        alignContent: 'flex-end',
        justifyContent: 'flex-end',
    }
});

const mapDispatchToProps = (dispatch) => {
    return {
        togglePrivacySettingsModal: (visible) => dispatch(togglePrivacySettingsModal(visible)),
    }
}

WorkoutPartnersScreen = connect(state => {
    return {
        isModalVisible: state.ui.privacySettingsModalVisible,
    };
}, mapDispatchToProps)(WorkoutPartnersScreen)
WorkoutPartnersScreen = translate(['workoutPartners'], { wait: true })(WorkoutPartnersScreen);
export default UserDataConsumer(WorkoutPartnersScreen);
